import React, { useState, useContext } from "react";
import UserContext from "../../context/UserContext";
import { useCart } from "react-use-cart";
import { Form, Button } from "react-bootstrap";
import Axios from "axios";
import "./oder.css";
import { API_URL } from "../../constants";
import { IMG_URL } from "../../constants";

function Oder() {
  const { userData } = useContext(UserContext);

  const [pname, setPname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [special, setSpecial] = useState("");

  const { cartTotal, items, emptyCart } = useCart();

  const price = items.map((item) => item.price);
  const name = items.map((item) => item.name);
  const quantity = items.map((item) => item.quantity);
  // const image = items.map((item) => item.image);

  console.log(price);
  console.log(name);
  console.log(quantity);
  console.log(cartTotal);

  const Submit = (e) => {
    e.preventDefault();
    const url = `${API_URL}/api/create/oder`;
    Axios.post(url, {
      name: name,
      price: price,
      quanity: quantity,
      total: cartTotal,
      pname: pname,
      email: email,
      phone: phone,
      address: address,
      special: special,
    }).then(() => {
      alert("Your Oder Has Been Placed");
      emptyCart();
      window.location.reload();
    });
  };

  return (
    <>
      {userData.user ? (
        <div className="oder  py-4 container ">
          <div className="oder_left ">
            {items.map((item) => {
              return (
                <div>
                  <div className="product_Detaisl">
                    <img
                      src={IMG_URL + item.image}
                      alt=""
                      style={{ height: "4rem", margin: "5px" }}
                    />
                    <p style={{ margin: "5px" }}>{item.name}</p>
                    <p style={{ margin: "5px" }}>x {item.quantity}</p>
                    <i style={{ margin: "5px", color: "red" }}>${item.price}</i>
                  </div>
                  <hr />
                </div>
              );
            })}

            <div className="total">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <b>Shipping : </b>
                <i>Calculated </i>
              </div>
              <hr />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                <b>Delivery : </b>
                <i> Home Delivery(free), 6-9 days </i>
              </div>
              <hr />
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <b>Total : </b>
                <i style={{ color: "purple" }}>${cartTotal}</i>
              </div>
            </div>
          </div>

          <div className="oder_right">
            <Form>
              <Form.Group className="mb-3" controlId="formBasicText">
                <Form.Label>Name:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  value={pname}
                  onChange={(e) => setPname(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address:</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicText">
                <Form.Label>Phone:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone Number:"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicText">
                <Form.Label>Adress:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Adress"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicText">
                <Form.Label>Special Requests :</Form.Label>
                <Form.Control
                  value={special}
                  onChange={(e) => setSpecial(e.target.value)}
                  as="textarea"
                  rows={3}
                  placeholder="Some Requests..."
                />
              </Form.Group>

              <div className="d-grid gap-2">
                <Button variant="dark" type="submit" size="lg" onClick={Submit}>
                  Place Final Oder
                </Button>
              </div>
            </Form>
          </div>
        </div>
      ) : (
        <div>Please Sign-In</div>
      )}
    </>
  );
}

export default Oder;
